const profileIcon = `
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
        <path
            d="M12 11C14.2091 11 16 9.20914 16 7C16 4.79086 14.2091 3 12 3C9.79086 3 8 4.79086 8 7C8 9.20914 9.79086 11 12 11Z"
            stroke="currentColor" stroke-width="2"/>
        <path
            d="M4.63406 16.0068C4.81984 15.4241 5.18463 14.9159 5.67587 14.5552C6.16712 14.1946 6.75946 14.0002 7.36755 14H16.5788C17.8268 14 18.9321 14.8115 19.3134 16.008L19.8708 17.7545C20.2876 19.0639 19.6759 20.3922 18.3275 20.6179C16.9873 20.8437 14.9528 21.035 11.9714 20.9946C9.13399 20.9566 7.15501 20.7736 5.81601 20.5752C4.38728 20.3625 3.69062 18.9676 4.13105 17.5822L4.63406 16.0068Z"
            stroke="currentColor" stroke-width="2"/>
    </svg>
`

export const Widget = {
    computed: {
        authorized() {
            return this.$store.state.authorized === true
        },
        cabinetUrl() {
            return (window.siteDir || '/') + 'personal/'
        }
    },
    methods: {
        openAuth() {
            popupOpen('auth')
        }
    },
    // Авторизованному — обычная ссылка на кабинет (работает средний клик, видно адрес),
    // гостю — кнопка, открывающая попап авторизации.
    template: `
        <a v-if="authorized" class="svg-icon" :href="cabinetUrl">${profileIcon}</a>
        <span v-else class="svg-icon" @click="openAuth">${profileIcon}</span>
    `
}
